import React, { useState, useRef } from "react"
import { graphql, Link } from "gatsby"
import styled, { withTheme } from "styled-components"
import { BLOCKS } from "@contentful/rich-text-types"
import { MARKS } from "@contentful/rich-text-types"
import { INLINES } from '@contentful/rich-text-types'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Layout from "../components/layout/layout"
import Container, { Full, Quarter, Row, ThreeQuarter } from "../components/layout/container"
import SEO from "../components/seo/seo"
import PostCarousel from "../components/ui/post-carousel"
import List from "../components/ui/list"
import TraderCarousel from "../components/ui/trader-carousel"
import RecentPosts from "../components/sections/recent-posts"
import PlanVisit from "../components/sections/plan-your-visit"
import { Twitter } from 'react-social-sharing'
import LinkShare from "../images/social_link.svg"
import InstaShare from "../images/social_ig.svg"
import FbShare from "../images/social_fb.svg"
import TwitterShare from "../images/social_tw.svg"


const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  h1 {
      font-family: ${(props) => props.theme.fontGreen};
      letter-spacing: 0.05rem;
      text-transform: uppercase;
      font-size 3.5rem;
      margin: 0;
      padding-bottom: 2rem;
      width: 75%;
      line-height: 1;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
        width: 100%;
        font-size 2rem;
      }
      @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
        width: 100%;
        font-size 3rem;
      }
  }
  aside {
    display: none;
    .future {
        opacity: 1;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 0.5;
    }
    .feedback {
        opacity: 0.5;
    }
    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;

const Back = styled.div`
    cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-family: "Pharma Bold Condensed",sans-serif;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 0.5rem 0 0.5rem;
    margin-right: 6rem;
    a {
      text-decoration: none;
    }
    border-bottom: 3px solid ${props => props.theme.colors.primary};
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
      border-bottom: 1px solid ${props => props.theme.colors.tablet};
      margin-right: 0;
      margin-bottom: 2rem;
    }
    .arrow-left {
      position: relative;
      top: 5px;
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-right: 12px solid ${props => props.theme.colors.primary};
      margin-right: 2rem;
    }
`;

const Content = styled.div`
    margin: 2rem 0 3rem;
    img {
      width: 100%;
    }
`



const Twenty = styled.div`
  width: 25%;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
   width: 100%;
  }
`

const Three = styled.div`
  width: 75%;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
   width: 100%;
  }
`

const ContainerRowBlog = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 769px) {
    flex-direction: row;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
   flex-direction: column;
  }
`

const RightCol = styled.div`
    margin-left: 2rem;
    display: block;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      display: none;
    }
    .dates {
      margin-bottom: 1rem;
      p {
        margin: 0;
      }
    }
`

const Social = styled.ul`
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      display: inline-block;
      padding-top: 3px;
      border-left: 1px solid ${props => props.theme.colors.secondary};
      border-top: 1px solid ${props => props.theme.colors.secondary};
      border-bottom: 1px solid ${props => props.theme.colors.secondary};
      a {
        cursor: pointer;
      }
      &:last-child{
        border-right: 1px solid ${props => props.theme.colors.secondary};
      }
    }
`

const ExtLinks = styled.ul`
  margin: 1rem 0 0 0;
  padding: 0;
  font-family: ${(props) => props.theme.fontCondensed};
  li {
    list-style: none;
    margin-bottom: 0.5rem;
    a {
      text-decoration: none; 
      border-bottom: 1px solid ${props => props.theme.colors.primary};
    }
  }
`

const TraderList = styled.div`
    background-color: #EED0C7;
    padding: 2rem;
    margin-top: 2rem;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      // margin-left: -2rem;
      // margin-right: -2rem;
    }
  span {
        font-size 0.6rem;
        margin-bottom: 1rem;
        display: block;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
    grid-auto-rows: 25px;
    column-gap: 2rem;
    row-gap: 1rem;
    list-style: none;
    list-style: none;
    margin: 0;
    padding: 0;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      grid-template-columns: auto;
    }
    li {
      list-style: none;
      font-family: ${(props) => props.theme.fontCondensed};
      box-sizing: border-box;
      border-bottom: 3px solid ${props => props.theme.colors.primary};
      a {text-decoration: none;}
    }
  }
  
`

const Contacts = styled.div`
    background-color: #EED0C7;
    padding: 2rem;
    margin-top: 2rem;
    span {
        font-size 0.6rem;
        margin-bottom: 1rem;
        display: block;
    }
    .left {
        padding-right: 1.5rem;
    }
    .right {
        padding-left: 1.5rem;
    }
    
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        
        li {
            svg {
                padding-left: 1rem;
                top: 3px;
                position: relative;
            }
            display: flex;
            font-family: ${(props) => props.theme.fontCondensed};
            flex-direction: row;
            justify-content: space-between;
            padding: 0.5rem 0 0.5rem;
            margin: 0;
            border-bottom: 2px solid ${props => props.theme.colors.primary};
        }
    }
`

const MobileEvents = styled.div`
    display: none;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      display: block;
      .holder {
        display: flex;
        justify-content: space-between;
      }
      .dates {
        width: 140px;
      }
    }
`



export const query = graphql`
         query($slug: String!) {
           contentfulWhatsOn(slug: { eq: $slug }) {
             title
             slug
             metaDescription {
                metaDescription
              }
             category
             publishedDate(formatString: "Do MMMM, YYYY")
              standfirst {
                standfirst
              }
             featuredImage {
               gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
               file {
                 url
               }
             }
            imageGallery {
              id
              gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
            }
             body {
               raw
                references {
                    ... on ContentfulAsset {
                        title
                        description
                        contentful_id
                        __typename
                        fixed(width: 800) {
                            width
                            height
                            src
                            srcSet
                        }
                    }
                }
             }
             eventDates {
               eventDates
             }
             eventLinks {
              linkName
              linkUrl
              }
              tradersTakingPartList {
                traderLink
                traderName
              }
           }
         }
       `;

const options: any = {
  renderMark: {
    [MARKS.CODE]: (embedded: any) => (
      <div dangerouslySetInnerHTML={{ __html: embedded }} />
    ),
  },
  renderNode: {
    "embedded-asset-block": (node) => {
      //const alt = node.data.target.fields.title["en-GB"];
      const url = node.data.target.fixed.src;
      return <img src={url} />;
    },
    [INLINES.HYPERLINK]: (node) => {
      return <a href={node.data.uri} target="_blank" rel="noopener noreferrer">{node.content[0].value}</a>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (_node: any) => {
        const entry = _node.data.target

        if (
          entry.sys.type === "Entry" &&
          entry.sys.contentType.sys.id === "traderListHolder"
        ) {
          return (
            <List>
              
            </List>
          )
        } else if (
          entry.sys.type === "Entry" &&
          entry.sys.contentType.sys.id !== "smallPrint"
        ) {
          return entry.fields.text["en-GB"].content.map((c: any, i: number) => (
            <p key={i}>
              <Small>{c.content.map((text: any) => text.value)}</Small>
            </p>
          ))
        }
      },

  },
};

const BlogPost = (props) => {
  

  const featuredImage = getImage(props.data.contentfulWhatsOn.featuredImage)
  const galleryImages = getImage(props.data.contentfulWhatsOn.imageGallery)
  console.log(props.data.contentfulWhatsOn.imageGallery);
  console.log(featuredImage);
         //check for empty fields
  if (props.data.contentfulWhatsOn.featuredImage === null) {
    var featuredImageTrue = false;
    var fixedOG = "";
  }
  else if (props.data.contentfulWhatsOn.featuredImage != null) {
    var featuredImageTrue = true;
    var fixedOG = "https:" + props.data.contentfulWhatsOn.featuredImage.file.url;
  }
  

    //check for empty fields
  if (props.data.contentfulWhatsOn.eventDates === null) {
    var eventDatesTrue = false;
  }
  else if (props.data.contentfulWhatsOn.eventDates != null) {
    var eventDatesTrue = true;
  }

     //check for empty fields
  if (props.data.contentfulWhatsOn.eventLinks === null) {
    var eventLinksTrue = false;
  }
  else if (props.data.contentfulWhatsOn.eventLinks != null) {
    var eventLinksTrue = true;
  }
     //check for empty fields
  if (props.data.contentfulWhatsOn.tradersTakingPartList === null) {
    var tradersTakingPartListTrue = false;
  }
  else if (props.data.contentfulWhatsOn.tradersTakingPartList != null) {
    var tradersTakingPartListTrue = true;
  }

       //check for empty fields
  if (props.data.contentfulWhatsOn.imageGallery === null) {
    var postImageGalleryTrue = false;
  }
  else if (props.data.contentfulWhatsOn.imageGallery != null) {
    var postImageGalleryTrue = true;
  }
//console.log (props.data.contentfulWhatsOn.ImageGallery);

  const url = typeof window !== 'undefined' ? window.location.href : '';

  const [copySuccess, setCopySuccess] = useState("")
  const textAreaRef = useRef(null)

  async function copyToClip() {
      await navigator.clipboard.writeText(location.href);
      setCopySuccess("Copied");
  }

  return (
    <Layout>
        <Section id="blog-post">
          <Container>
            <SEO
              title={props.data.contentfulWhatsOn.title}
              description={props.data.contentfulWhatsOn.metaDescription.metaDescription}
              image={fixedOG}
            />
            <Row>
              <Quarter>
                <Back>
                    <div className="arrow-left"></div>
                    <Link to="/news/">Back</Link>
                </Back>
              </Quarter>
                <ThreeQuarter>
                  <h1>{props.data.contentfulWhatsOn.title}</h1>
                  <ContainerRowBlog>
                    <Three>
                      {postImageGalleryTrue ? (
                          <TraderCarousel>{props.data.contentfulWhatsOn.imageGallery.map(photo=>{
                            return <GatsbyImage image={photo.gatsbyImageData} />
                        })}</TraderCarousel>
                        ) : (
                          featuredImageTrue ? (
                              <GatsbyImage image={props.data.contentfulWhatsOn.featuredImage.gatsbyImageData} alt={props.data.contentfulWhatsOn.title} />
                              ) : null
                          
                        )}
                        
                        <Content>
                          <MobileEvents>
                            <div className="holder">
                            {eventDatesTrue ? (
                                <div className="dates">
                                    <p>{props.data.contentfulWhatsOn.eventDates.eventDates}</p>
                                </div>
                                ) : null}
                                <Social>
                                  <li><a onClick={copyToClip}><LinkShare /></a></li>
                                  <li><a href={'https://www.facebook.com/sharer/sharer.php?u=' + url}><FbShare /></a></li>
                                  {/* <li><a href=""><InstaShare /></a></li> */}
                                  <li><a href={'https://twitter.com/intent/tweet?url=' + url}><TwitterShare /></a></li>
                              </Social>
                            </div>
                              {eventLinksTrue ? (
                                <ExtLinks>
                                    {props.data.contentfulWhatsOn.eventLinks.map(
                                      (link, index) => (
                                        <li key={index}><a href={link.linkUrl}>{link.linkName}</a></li>
                                      )
                                    )}
                                </ExtLinks>
                              ) : null}
                            </MobileEvents>
                            {renderRichText(props.data.contentfulWhatsOn.body, options)}
                            {tradersTakingPartListTrue ? (
                              <TraderList>
                                <span>Traders taking part</span>
                                <ul>
                                  {props.data.contentfulWhatsOn.tradersTakingPartList.map(
                                    (link, index) => (
                                      
                                      <li key={index}><a href={`/trader-directory/${link.traderLink}/`}>{link.traderName}</a></li>
                                    )
                                  )}
                                </ul>
                              </TraderList>
                            ) : null}
                        </Content>
                        
                        
                    </Three>
                    <Twenty>
                      <RightCol>
                        {eventDatesTrue ? (
                          <div className="dates">
                              <p>{props.data.contentfulWhatsOn.eventDates.eventDates}</p>
                          </div>
                        ) : null}
                        <Social>
                          <li><a onClick={copyToClip}><LinkShare /></a></li>
                          <li><a href={'https://www.facebook.com/sharer/sharer.php?u=' + url}><FbShare /></a></li>
                          {/* <li><a href=""><InstaShare /></a></li> */}
                          <li><a href={'https://twitter.com/intent/tweet?url=' + url}><TwitterShare /></a></li>
                        </Social>
                        {eventLinksTrue ? (
                          <ExtLinks>
                              {props.data.contentfulWhatsOn.eventLinks.map(
                                (link, index) => (
                                  <li key={index}><a href={link.linkUrl}>{link.linkName}</a></li>
                                )
                              )}
                          </ExtLinks>
                        ) : null}
                      </RightCol>
                    </Twenty>
                  </ContainerRowBlog>
                  <Row>
                    <Full>
                      <RecentPosts />
                      <PlanVisit />
                    </Full>
                  </Row>
                </ThreeQuarter>
            </Row>
          </Container>
        </Section>
    </Layout>
  );
};

export default BlogPost;
